<template>
  <div class="main">
    <!-- // 异步获取 slides 的时候, 需要在 wc-swiper 上面添加 v-if 判断 -->
    <wc-swiper :duration="4000" :interval="2000" v-if="swiperList.length" class="swiper">
      <wc-slide
        class="swiper-item"
        @click="linkToSwipe(item)"
        v-for="(item, key) in swiperList"
        :key="key"
      >
        <img :src="item.thumb" alt />
      </wc-slide>
    </wc-swiper>
    <div class="user-wrap">
      <p class="title">个人信息</p>
      <div class="my-info">
        <p v-if="!loginStatu" @click="linkToLogin" class="login-tip">还未登录，立即登录</p>
        <div @click="linkToMine" v-else class="server-list">
          <div class="list-item">
            <div class="img-wrap">
              <img :src="head" alt />
            </div>
            <div>我的预约</div>
          </div>
        </div>
      </div>
    </div>

    <div class="server-wrap">
      <p class="title">常用服务</p>
      <div class="server-list">
        <div @click="linkTo(item)" v-for="(item,index) in navList" :key="index">
          <div class="list-item">
            <div class="img-wrap">
              <img :src="item.icon" alt />
            </div>
            <div style="text-align:center;width:100px" class="no-wrap">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navigationList, advertList, insInfo } from "@/api/api.js";
import { compare, urlSearchObj } from "@/utils/util.js";
import head from "@/assets/img/noHead.jpg";
import { isEmpty, cacheGet, cacheSet } from "@/utils/util.js";
import { Toast } from "mint-ui";
import guide from "@/assets/img/guide.png";
import recommend from "@/assets/img/recommend.png";
import experience from "@/assets/img/experience.png";
import live from "@/assets/img/live.png";
import act from "@/assets/img/act.png";
export default {
  data() {
    return {
      guide,
      recommend,
      experience,
      live,
      act,
      head,
      swiperList: [],
      navList: [],
    };
  },
  computed: {
    loginStatu() {
      if (isEmpty(cacheGet("token"))) {
        return false;
      }
      return cacheGet("token");
    },
  },
  mounted() {
    insInfo().then((res) => {
      let org_id = res.instanceInfo.orgInfo.orgId;
      navigationList({
        org_id,
      }).then((res) => {
        res.sort(compare("is_system"));
        res.forEach(item => {
          item['img'] = "//" + item.icon.replace(/^http:\/\//, '')
        })
        this.navList = res;
      });
      advertList({
        org_id,
      }).then((res) => {
        this.swiperList = res;
      }).catch(err => {
      }) ;
    });
  },
  methods: {
    linkToSwipe(item) {
      if (item.link.indexOf("http") > -1) {
        window.location.href = item.link;
      }
    },
    linkToLogin() {
      this.$router.push("/login");
    },
    linkToMine() {
      this.$router.push("/mine");
    },

    linkTo(item) {
      if (item.link.indexOf("http") > -1) {
        item.link = item.link.replace("{instance}", urlSearchObj().id);
        window.location.href = item.link;
      } else if (item.link.indexOf("wx") > -1) {
        window.location.href = `https://miniapp.bookan.com.cn/?id=${
          urlSearchObj().id
        }`;
      } else {
        let token = cacheGet("token");
        if (item.link == "/experience") {
          if (isEmpty(token)) {
            Toast("请您先登录");
            return;
          }
        }
        this.$router.push(item.link);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.btn {
  width: 100px;
  height: 100px;
}
.swiper {
  width: 100vw;
  height: 4.5rem;
  .swiper-item {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.login-tip {
  padding-bottom: 10px;
  color: #006feb;
  border-bottom: 1px solid #006feb;
  // text-decoration: underline;
}
.main {
  .user-wrap {
    margin-top: 0.5rem;
    padding: 0 20px;
    width: 100%;
    .title {
      text-align: left;
      padding-bottom: 20px;
      border-bottom: 1px solid #ccc;
      font-size: 0.45rem;
      font-weight: 600;
    }
    .my-info {
      height: 220px;
      display: flex;
      align-items: center;
      .server-list {
        margin-top: 0.5rem;
        width: 100%;
        .list-item {
          float: left;
          width: 33.3%;
          height: 220px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .img-wrap {
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            background: #ccc;
            margin-bottom: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
  .server-wrap {
    margin-top: 0.5rem;
    padding: 0 20px;
    width: 100%;
    .title {
      text-align: left;
      padding-bottom: 20px;
      border-bottom: 1px solid #ccc;
      font-size: 0.45rem;
      font-weight: 600;
    }
    .server-list {
      margin-top: 0.5rem;
      width: 100%;
      .list-item {
        float: left;
        width: 33.3%;
        height: 220px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img-wrap {
          width: 2rem;
          height: 2rem;
          border-radius: 50%;
          background: #ccc;
          margin-bottom: 10px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>

